function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { map, isEmpty, noop } from "lodash";
import { Button, Checkbox, Menu, MenuItem, Classes, InputGroup, Popover, Switch } from "@blueprintjs/core";

var DisplayOptions = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DisplayOptions, _React$Component);

  function DisplayOptions() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      searchTerms: {}
    });

    _defineProperty(_assertThisInitialized(_this), "openPopover", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeTableDensity", function (e) {
      var _this$props$updateTab = _this.props.updateTableDisplayDensity,
          updateTableDisplayDensity = _this$props$updateTab === void 0 ? noop : _this$props$updateTab;
      updateTableDisplayDensity(e.target.value);

      _this.closePopover();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleForcedHidden", function (e) {
      return _this.props.setShowForcedHidden(e.target.checked);
    });

    return _this;
  }

  var _proto = DisplayOptions.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        searchTerms = _this$state.searchTerms;
    var _this$props = this.props,
        schema = _this$props.schema,
        _this$props$updateCol = _this$props.updateColumnVisibility,
        updateColumnVisibility = _this$props$updateCol === void 0 ? noop : _this$props$updateCol,
        _this$props$resetDefa = _this$props.resetDefaultVisibility,
        resetDefaultVisibility = _this$props$resetDefa === void 0 ? noop : _this$props$resetDefa,
        compact = _this$props.compact,
        extraCompact = _this$props.extraCompact,
        disabled = _this$props.disabled,
        hasOptionForForcedHidden = _this$props.hasOptionForForcedHidden,
        showForcedHiddenColumns = _this$props.showForcedHiddenColumns,
        hideDisplayOptionsIcon = _this$props.hideDisplayOptionsIcon;

    if (hideDisplayOptionsIcon) {
      return null; //don't show antyhing!
    }

    var fields = schema.fields;
    var fieldGroups = {};
    var mainFields = [];
    fields.forEach(function (field) {
      if (field.hideInMenu) return;
      if (!field.fieldGroup) return mainFields.push(field);
      if (!fieldGroups[field.fieldGroup]) fieldGroups[field.fieldGroup] = [];
      fieldGroups[field.fieldGroup].push(field);
    });
    var numVisible = 0;

    var getFieldCheckbox = function getFieldCheckbox(field, i) {
      var displayName = field.displayName,
          isHidden = field.isHidden,
          isForcedHidden = field.isForcedHidden,
          path = field.path;
      if (isForcedHidden) return;
      if (!isHidden) numVisible++;
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: path || i,
        onChange: function onChange() {
          if (numVisible <= 1 && !isHidden) {
            return window.toastr.warning("We have to display at least one column :)");
          }

          updateColumnVisibility({
            shouldShow: isHidden,
            path: path
          });
        },
        checked: !isHidden,
        label: displayName
      });
    };

    var fieldGroupMenu;

    if (!isEmpty(fieldGroups)) {
      fieldGroupMenu = map(fieldGroups, function (groupFields, groupName) {
        var searchTerm = searchTerms[groupName] || "";
        var anyVisible = groupFields.some(function (field) {
          return !field.isHidden && !field.isForcedHidden;
        });
        var anyNotForcedHidden = groupFields.some(function (field) {
          return !field.isForcedHidden;
        });
        if (!anyNotForcedHidden) return;
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: groupName,
          text: groupName
        }, /*#__PURE__*/React.createElement(InputGroup, {
          leftIcon: "search",
          value: searchTerm,
          onChange: function onChange(e) {
            var _extends2;

            _this2.setState({
              searchTerms: _extends({}, searchTerms, (_extends2 = {}, _extends2[groupName] = e.target.value, _extends2))
            });
          }
        }), /*#__PURE__*/React.createElement(Button, {
          className: Classes.MINIMAL,
          text: (anyVisible ? "Hide" : "Show") + " All",
          style: {
            margin: "10px 0"
          },
          onClick: function onClick() {
            updateColumnVisibility({
              shouldShow: !anyVisible,
              paths: groupFields.map(function (field) {
                return field.path;
              })
            });
          }
        }), groupFields.filter(function (field) {
          return field.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
        }).map(getFieldCheckbox));
      });
    }

    return /*#__PURE__*/React.createElement(Popover, {
      isOpen: isOpen,
      onClose: this.closePopover,
      content: /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 10,
          paddingLeft: 20,
          paddingRight: 20
        }
      }, /*#__PURE__*/React.createElement("h5", {
        style: {
          marginBottom: 10
        }
      }, "Display Density:"), /*#__PURE__*/React.createElement("div", {
        className: Classes.SELECT + " tg-table-display-density"
      }, /*#__PURE__*/React.createElement("select", {
        onChange: this.changeTableDensity,
        value: extraCompact ? "extraCompact" : compact ? "compact" : "normal"
      }, /*#__PURE__*/React.createElement("option", {
        className: Classes.POPOVER_DISMISS,
        value: "normal"
      }, "Comfortable"), /*#__PURE__*/React.createElement("option", {
        className: Classes.POPOVER_DISMISS,
        value: "compact"
      }, "Normal"), /*#__PURE__*/React.createElement("option", {
        className: Classes.POPOVER_DISMISS,
        value: "extraCompact"
      }, "Compact"))), /*#__PURE__*/React.createElement("h5", {
        style: {
          marginBottom: 10,
          marginTop: 10
        }
      }, "Displayed Columns:"), /*#__PURE__*/React.createElement("div", {
        style: {
          maxHeight: 260,
          overflowY: "auto",
          padding: 2
        }
      }, mainFields.map(getFieldCheckbox)), /*#__PURE__*/React.createElement("div", null, fieldGroupMenu), hasOptionForForcedHidden && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 15
        }
      }, /*#__PURE__*/React.createElement(Switch, {
        label: "Show Empty Columns",
        checked: showForcedHiddenColumns,
        onChange: this.toggleForcedHidden
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          display: "flex",
          justifyContent: "flex-end"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: resetDefaultVisibility,
        title: "Display Options",
        minimal: true
      }, "Reset"))))
    }, /*#__PURE__*/React.createElement(Button, {
      className: "tg-table-display-options",
      onClick: this.openPopover,
      disabled: disabled,
      minimal: true,
      icon: "cog"
    }));
  };

  return DisplayOptions;
}(React.Component);

export { DisplayOptions as default };